import { createEvent, createStore } from 'effector'

export const actions = {
  setUsers: createEvent<UserResponse[]>('setUsers'),
  resetUsers: createEvent('resetUsers'),

  setManifestations: createEvent<ManifestationResponse[]>('setManifestations'),
  resetManifestations: createEvent('resetManifestations'),

  setServices: createEvent<SocieteResponse[]>('setServices'),
  resetServices: createEvent('resetServices'),

  setRoles: createEvent<RoleResponse[]>('setRoles'),
  resetRoles: createEvent('resetRoles'),

  setPlans: createEvent<Plan[]>('setPlans'),
  resetPlans: createEvent('resetPlans'),

  setSpaces: createEvent<LocalisationResponse[]>('setSpaces'),
  resetSpaces: createEvent('resetSpaces'),

  reset: createEvent('reset'),
}

const initialState: AdminState = {
  users: [],
  manifestations: [],
  services: [],
  roles: [],
  plans: [],
  spaces: [],
}

export const store = createStore<AdminState>(initialState, { name: 'admin' })
  .on(actions.setUsers, (s, users) => ({ ...s, users }))
  .on(actions.resetUsers, (s) => ({ ...s, users: initialState.users }))
  .on(actions.setManifestations, (s, manifestations) => ({ ...s, manifestations }))
  .on(actions.resetManifestations, (s) => ({ ...s, manifestations: initialState.manifestations }))
  .on(actions.setServices, (s, services) => ({ ...s, services }))
  .on(actions.resetServices, (s) => ({ ...s, services: initialState.services }))
  .on(actions.setRoles, (s, roles) => ({ ...s, roles }))
  .on(actions.resetRoles, (s) => ({ ...s, roles: initialState.roles }))
  .on(actions.setPlans, (s, plans) => ({ ...s, plans }))
  .on(actions.resetPlans, (s) => ({ ...s, plans: initialState.plans }))
  .on(actions.setSpaces, (s, spaces) => ({ ...s, spaces }))
  .on(actions.resetSpaces, (s) => ({ ...s, spaces: initialState.spaces }))
  .on(actions.reset, () => initialState)
